import { render, staticRenderFns } from "./WebpartListItem.vue?vue&type=template&id=b324f8b8"
import script from "./WebpartListItem.vue?vue&type=script&lang=ts"
export * from "./WebpartListItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports